// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__35YOj","content":"GlobalSearch_content__1qVLY"};